/**
 * Fallback article taxonomy when GET /api/config/company-profile is empty or fails.
 * Live values come from `article_categories` and `article_tags` on the company profile (per tenant).
 */
export const DEFAULT_ARTICLE_CATEGORIES = [
  'News',
  'Lifestyle',
  'Culture',
  'Opinion',
  'Sports',
  'Technology',
  'Business',
  'Science',
  'Local',
  'World',
] as const;

/** @deprecated use DEFAULT_ARTICLE_CATEGORIES — kept for any external imports */
export const ARTICLE_EDITOR_CATEGORIES = [...DEFAULT_ARTICLE_CATEGORIES] as string[];

export function normalizeArticleCategory(
  raw: string | undefined,
  categories: readonly string[] = [...DEFAULT_ARTICLE_CATEGORIES]
): string {
  const list = categories.length ? categories : [...DEFAULT_ARTICLE_CATEGORIES];
  const t = (raw || '').trim();
  const hit = list.find((c) => c.toLowerCase() === t.toLowerCase());
  return hit || list[0] || 'News';
}

export const DEFAULT_ARTICLE_TAG_POOL: string[] = [
  'breaking',
  'analysis',
  'interview',
  'investigation',
  'opinion',
  'feature',
  'guide',
  'review',
  'profile',
  'data',
  'climate',
  'health',
  'education',
  'economy',
  'politics',
  'community',
  'arts',
  'food',
  'travel',
  'science',
  'technology',
  'sports',
  'culture',
  'local-news',
  'world-news',
];

/** @deprecated use DEFAULT_ARTICLE_TAG_POOL */
export const ARTICLE_TAG_POOL = DEFAULT_ARTICLE_TAG_POOL;

export function sanitizeArticleTagsAgainstPool(raw: string[] | undefined, pool: readonly string[]): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const t of raw || []) {
    const canon = pool.find((p) => p.toLowerCase() === String(t).trim().toLowerCase());
    if (canon && !seen.has(canon) && out.length < 5) {
      seen.add(canon);
      out.push(canon);
    }
  }
  return out;
}
